// extracted by mini-css-extract-plugin
module.exports = {"root":"option-input_root__1QO-d","container":"option-input_container__1Kd1J","box":"option-input_box__2Qdy8","dot":"option-input_dot__2Ypvm","label":"option-input_label__pOI9V"};